<template>
  <div
    class="engagement-result-sub-wall"
    data-test-id="engagement-result-sub-wall"
  >
    <h2 class="engagement-result-sub-wall__heading">
      Thank you for sharing
    </h2>
    <p class="engagement-result-sub-wall__copy">
      Want to know how the rest of the community responded?
    </p>
    <button-component
      class="engagement-result-sub-wall__cta-button button button--secondary"
      data-test-id="engagement-result-sub-wall-button"
      @click="openLeadGenFormInDialog"
    >
      Subscribe to view results
    </button-component>
  </div>
</template>

<script>
import ButtonComponent from '@/components/Global/ButtonComponent.vue';

export default {
  name: 'EngagementResultSubWall',
  components: {
    ButtonComponent,
  },
  props: {
    engagementType: {
      type: String,
      required: true,
    },
  },
  methods: {
    openLeadGenFormInDialog() {
      this.$store.dispatch('openLeadGenFormInDialog', true);
      this.$store.dispatch('setEngagementSubWallStatus', true);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_engagement-result-sub-wall';
</style>
